import React from 'react'
import {Icon} from '@chakra-ui/react'
const CloseIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" cursor="pointer" fill="transparent" {...props}>
            <path
                d="M18.2068 4L11.4993 10.7088L4.79187 4L3 5.79315L9.70748 12.5006L3 19.2082L4.79187 21L11.4993 14.2924L18.2068 21L20 19.2082L13.2912 12.5006L20 5.79315L18.2068 4Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CloseIcon
